export default __webpack_public_path__ + "static/media/menu-p-d-b.3c5442c0.png";